module.exports = __webpack_public_path__ + "static/media/one.aa4232c6.svg";